export function modal() {
  const modals = [
    document.getElementById('js-modal-01'),
    document.getElementById('js-modal-02'),
    document.getElementById('js-modal-03'),
    document.getElementById('js-modal-04'),
    document.getElementById('js-modal-05')
  ];

  const buttonsOpen = [
    document.querySelectorAll('.js-modal_01'),
    document.querySelectorAll('.js-modal_02'),
    document.querySelectorAll('.js-modal_03'),
    document.querySelectorAll('.js-modal_04'),
    document.querySelectorAll('.js-modal_05')
  ];

  const buttonClose = document.querySelectorAll('.js-modal_close');
  const buttonCloseBtns = document.querySelectorAll('.js-modal_close_btn'); 
  const modalMusk = document.getElementById('js-modal_musk');

  buttonsOpen.forEach((buttons, index) => {
    buttons.forEach(button => {
      button.addEventListener('click', () => modalOpen(index));
    });
  });

  function modalOpen(index) {
    modals[index].classList.add('is-active');
    modalMusk.classList.add('is-active');
    buttonCloseBtns.forEach(btn => btn.classList.add('is-active'));
  }

  buttonClose.forEach(button => {
    button.addEventListener('click', modalClose);
  });

  function modalClose() {
    modals.forEach(modal => modal.classList.remove('is-active'));
    modalMusk.classList.remove('is-active');
    buttonCloseBtns.forEach(btn => btn.classList.remove('is-active'));
  }
}